import React from "react"
import Cabecalho from "../Cabecalho"
import { FormularioCoresAplicativo } from "./components/FormularioCoresAplicativo"

export function CadastroAplicativoFornecedor() {
    return (
        <>
            <Cabecalho pagina="Cores do Site" />
            <FormularioCoresAplicativo />
        </>
    )
}
